/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Agensi_D4dInputs */

const en_mk_sol_agensi_d4d = /** @type {(inputs: Mk_Sol_Agensi_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The agent asks permission before scheduling the post. The owner’s approval is stored with its time and its reason.`)
};

const id_mk_sol_agensi_d4d = /** @type {(inputs: Mk_Sol_Agensi_D4dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen mengajukan izin sebelum menjadwalkan unggahan. Persetujuan pemilik tersimpan dengan waktu dan alasannya.`)
};

/**
* | output |
* | --- |
* | "The agent asks permission before scheduling the post. The owner’s approval is stored with its time and its reason." |
*
* @param {Mk_Sol_Agensi_D4dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_agensi_d4d = /** @type {((inputs?: Mk_Sol_Agensi_D4dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Agensi_D4dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_agensi_d4d(inputs)
	return en_mk_sol_agensi_d4d(inputs)
});